import type { EasyblocksEditorContext } from "./types";

export function dotNotationGet(obj: unknown, path: string): unknown {
  if (!path) return obj;
  return path
    .split(".")
    .reduce<unknown>((acc, key) => (acc && typeof acc === "object" ? (acc as Record<string, unknown>)[key] : undefined), obj);
}

export function getEditorContext(): EasyblocksEditorContext | undefined {
  if (typeof window === "undefined") return undefined;
  return (window.parent as { editorWindowAPI?: { editorContext?: EasyblocksEditorContext } })?.editorWindowAPI?.editorContext;
}

export function changeEditorFormValue(path: string | undefined, serialized: string): boolean {
  if (!path) return false;
  const editorContext = getEditorContext();
  if (!editorContext?.form) return false;
  editorContext.form.change(`${path}.delta`, serialized);
  return true;
}

